import { Component } from '@angular/core';

@Component({
  selector: 'loading-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class LoadingSpinnerComponent {

}
